module.exports = __webpack_public_path__ + "img/sf.2c6ed590.jpg";